import { FormikHelpers } from "formik";
import { useGetPhoneLine } from "./api/getPhoneLine";
import { useEditPhoneLine } from "./api/editPhoneLine";
import EditPhoneLineForm from "./EditPhoneLineForm";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import { useState } from "react";
import PhoneLineBillingReport from "./PhoneLineBillingReport";


const EditPhoneLine = ({handleCloseModal, phoneLineId}: EditPhoneLineProps)  => {
  const [isBillingReportModalVisible, setIsBillinReportgModalVisible] = useState(false);

  const handleBillingReportButtonClick = () => {
    setIsBillinReportgModalVisible(true); 
  };

  const handleCloseBillingReportModal = () => {
    setIsBillinReportgModalVisible(false); 
  };
  
  const getPhoneLineQuery = useGetPhoneLine({phoneLineId: phoneLineId})
  const editPhoneLineMutation = useEditPhoneLine({data: {}, phoneLineId});

  const initialApplDate = getPhoneLineQuery.data?.applDate ? new Date(getPhoneLineQuery.data.applDate) : null;
  const initialOffApplDate = getPhoneLineQuery.data?.offApplDate ? new Date(getPhoneLineQuery.data.offApplDate) : null;
  const initialDeliveryDate = getPhoneLineQuery.data?.deliveryDate ? new Date(getPhoneLineQuery.data.deliveryDate) : null;
  const initialRemovalDate = getPhoneLineQuery.data?.removalDate ? new Date(getPhoneLineQuery.data.removalDate) : null;


  const initialValues: IEditPhoneLineForm = {
    unitID: getPhoneLineQuery.data?.unitID ? getPhoneLineQuery.data.unitID.toString() : "",
    applProtocolNumber: getPhoneLineQuery.data?.applProtocolNumber ? getPhoneLineQuery.data.applProtocolNumber : "",
    applDate: initialApplDate,
    offApplDate: initialOffApplDate,
    deliveryDate: initialDeliveryDate,
    pendingStatusID:  getPhoneLineQuery.data?.pendingStatusID ? getPhoneLineQuery.data.pendingStatusID.toString() : "",
    lineTypeID:  getPhoneLineQuery.data?.lineTypeID ? getPhoneLineQuery.data.lineTypeID.toString() : "",
    providerID:  getPhoneLineQuery.data?.providerID ? getPhoneLineQuery.data.providerID.toString() : "",
    usedByID:  getPhoneLineQuery.data?.usedByID  ? getPhoneLineQuery.data.usedByID.toString() : "",
    removalDate: initialRemovalDate,
    cost:  getPhoneLineQuery.data?.cost ? getPhoneLineQuery.data.cost.toString() : "",
    comments: getPhoneLineQuery.data?.comments ? getPhoneLineQuery.data.comments : "",
    sapCode: getPhoneLineQuery.data?.sapCode ? getPhoneLineQuery.data.sapCode : "",
    phoneNumber: getPhoneLineQuery.data?.phoneNumber ? getPhoneLineQuery.data.phoneNumber : "",
    lineType: getPhoneLineQuery.data?.lineType ? getPhoneLineQuery.data.lineType.toString() : "",
    isEmporiki:getPhoneLineQuery.data?.isEmporiki ? getPhoneLineQuery.data.isEmporiki : false,
    isCiti: getPhoneLineQuery.data?.isCiti ? getPhoneLineQuery.data.isCiti : false,
    deleted: getPhoneLineQuery.data?.deleted ? getPhoneLineQuery.data.deleted : false,
    descline: getPhoneLineQuery.data?.descline ? getPhoneLineQuery.data?.descline : ""
  }

  const unitType: string | undefined = getPhoneLineQuery.data?.unitType

  const handleSubmit = async (values: IEditPhoneLineForm, { setSubmitting }: FormikHelpers<IEditPhoneLineForm>): Promise<void> => {
    try {
      await editPhoneLineMutation.mutateAsync({
        data: values,
        phoneLineId: phoneLineId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
      setSubmitting(false);
    }
  }

  if (getPhoneLineQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getPhoneLineQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση της τηλεφωνικής γραμμής.</div>
    )
  }

  return (
    <>
      {!getPhoneLineQuery.isLoading && getPhoneLineQuery.data &&
        <EditPhoneLineForm 
          initialValues={initialValues} 
          onSubmit={handleSubmit} 
          unitType={unitType} 
          onBillingButtonClick={handleBillingReportButtonClick}
          isBillingModalActive={isBillingReportModalVisible}
        />
      }

      {isBillingReportModalVisible &&
        <PhoneLineBillingReport handleCloseModal={handleCloseBillingReportModal} phoneNumber={initialValues.phoneNumber} />
      }
    </>
  )
}

interface EditPhoneLineProps {
  phoneLineId: number;
  handleCloseModal: () => void;
}

export default EditPhoneLine;